import {httpGet} from "./index";
import axios from "axios";

export const init = async (data) => {
    let csrfCookie = await axios.get('/sanctum/csrf-cookie');
    if (csrfCookie) {
        let response = await httpGet('/v1/init', data);
        if (response) {
            return response.data;
        }
    }
};
